
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import * as ReactBootstrap from 'react-bootstrap';

import circum from '../Skills/images/circum_edit.svg';





function MasterJobFamily() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>

            
            <div className='col-lg-12 d-flex mt-2 pb-3'>
            <div className='col-lg-6'>
            <h4 className="text-start">JOB FAMILY MASTER </h4>
             </div>
             <div className='col-lg-6 text-end bg-white '>
            <a href='/AddJobFambut' className="text-decoration-none text-white" ><button type="button" class="btn btn-danger rounded-pill">Add JobFamily +</button></a>
            </div>   
            </div>
            <ReactBootstrap.Table striped bordered hover size="sm">
                <thead className='text-center'>
                    <tr>
                        <th>#</th>
                        <th>Job Family Name</th>
                        <th>Created By</th>
                        <th>Created At</th>
                        <th>Action</th>
                       
                    </tr>
                </thead>
              <tbody>
                <tr>
                    <td>1</td>
                    <td>Cargo Import/Export Mail</td>
                    <td>Manager</td>
                    <td>01/01/2024</td>
                    <td className='text-center'><img src={circum} alt="" />  
                    </td>  
                 </tr>

                 <tr>
                    <td>2</td>
                    <td>Tracing</td>
                    <td>Manager</td>
                    <td>01/01/2024</td>
                    <td className='text-center'><img src={circum} alt="" /></td>  
                 </tr>

                 <tr>
                    <td>3</td>
                    <td>service quality</td>
                    <td>Manager</td>
                    <td>01/01/2024</td>
                    <td className='text-center'><img src={circum} alt="" /> </td>  
                 </tr>

                 <tr>
                    <td>4</td>
                    <td>Administration</td>
                    <td>Manager</td>
                    <td>01/01/2024</td>
                    <td className='text-center'><img src={circum} alt="" /> </td>  
                 </tr>
              </tbody>
            </ReactBootstrap.Table>
       
                
            </BasicCard>
        </>
    )
}
export default MasterJobFamily;